import { KeyboardShortcutHandlerOpenOverlay } from '@/components/chat/_domain/modules/keyboard-shortcut-service/handlers/open-keyboard-shortcut-overlay';
import { KeyboardShortcutHandlerToggleChatFreeze } from '@/components/chat/_domain/modules/keyboard-shortcut-service/handlers/toggle-chat-freeze';
import { IKeyboardShortcutHandler } from '@/components/chat/_domain/modules/keyboard-shortcut-service/keyboard-shortcut-service-interface';

const keyboardShortcutHandlerTypes: { [key: string]: new() => IKeyboardShortcutHandler} = {
  KeyboardShortcutHandlerOpenOverlay,
  KeyboardShortcutHandlerToggleChatFreeze
};

export { keyboardShortcutHandlerTypes };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/keyboard-shortcut-service/handlers/index.ts